// extracted by css-extract-rspack-plugin
export default {"root":"root-TXRyV","selectedValue":"selectedValue-1AZV5","indicator":"indicator-1Co1h","disabled":"disabled-uL30c","listbox":"listbox-1KRYD"};